import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/shared/notification.service';
import { PatientService } from 'src/app/shared/patient.service';

@Component({
  selector: 'app-patient-login',
  templateUrl: './patient-login.component.html',
  styleUrls: ['./patient-login.component.scss']
})
export class PatientLoginComponent {
  patient = {
    mobile: null,
    hospital: null
  }
  otpSent = false;
  verifyAgain = false;
  isExpired  = null
  otp
  timeLeft: number = 30;
  interval


  redirectDelay: number = 0;
  showMessages: any = {};
  strategy: string = '';

  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  submitted: boolean = false;
  rememberMe = false;
  preRegister = false;
  salutations = [];
  preRegisterPatient = {
    salutation: '',
    patientname: '',
    mobile: '',
    gender : '',
    address: ''
  }
  genders = [];

  constructor(
    private notificationService: NotificationService,
    private patientService: PatientService,
    private router: Router
    ) {
      this.salutations = ['', 'Mr.', 'Ms.', 'Mrs.', 'Master', 'Baby', 'B/O', 'Dr.'];
      this.genders = ['male', 'female', 'other'];
  }

  async startTimer() {
    try {
      let data = {
        phone: this.patient.mobile
      }
      let response = await this.notificationService.generateOtp(data).toPromise();
      if (response['code'] == 200) {
        this.timeLeft = 30;
        this.isExpired = true;
        this.verifyAgain = false;
        this.otpSent = true;
        this.interval = setInterval(() => {
          if (this.timeLeft > 0) {
            this.timeLeft--;
          } else {
            this.isExpired = false;
            this.verifyAgain = true;
            clearInterval(this.interval);
          }
        }, 1000)
      }
    } catch (E) {
      console.log(E);
    } finally {
    }
  }

  async verified() {
    try {
      let data = {
        phone: this.patient.mobile,
        otp: this.otp
      }
      let response = await this.notificationService.verifyOtp(data).toPromise();
      if (response['data']['otp_verified']) {
        await this.authenticatePatient();
      }
    } catch (E) {
    } finally {
    }
  }
  async authenticatePatient() {
    try {
      const response = await this.patientService.authenticatePatient({
        mobile: this.patient.mobile,
      }).toPromise()
      if(response && response['data']) {
        localStorage.setItem('token', response['data']['token']);
        this.router.navigate(['patient-portal/lab-reports'])
      }
    } catch (error) {
      
    }
  }

  setPreRegisterPatient() {
    this.preRegister = !this.preRegister;
  }

  setGender() {
    if (this.preRegisterPatient.salutation == 'Mr.' || this.preRegisterPatient.salutation == 'Master') {
      this.preRegisterPatient.gender = 'male';
    } else if (this.preRegisterPatient.salutation == 'Mrs.' || this.preRegisterPatient.salutation == 'Ms.' || this.preRegisterPatient.salutation == 'Baby') {
      this.preRegisterPatient.gender = 'female';
    } else {
      this.preRegisterPatient.gender = '';
    }
  }

  isNumberValid() {
    return String(this.preRegisterPatient.mobile) && String(this.preRegisterPatient.mobile).length == 10;
  }

  patientNameSet($event) {
    this.preRegisterPatient.patientname = $event;
  }
  

  disableSubmit() {
    return !this.preRegisterPatient.address || !this.preRegisterPatient.gender || !this.preRegisterPatient.patientname || !this.isNumberValid()
  }
  async savePreRegisteration() {
    try {
      const data = {
        name: this.preRegisterPatient.patientname,
        address: this.preRegisterPatient.address,
        mobile: this.preRegisterPatient.mobile,
        gender: this.preRegisterPatient.gender,
        salutation: this.preRegisterPatient.salutation
      }
      const res = await this.patientService.createPreRegisteration(data).toPromise();
      if(res && res['data']) {
        this.setPreRegisterPatient();
      }
    } catch (error) {
      console.log(error)
    }

  }

}
